/**
 * @generated SignedSource<<21c7cd22619ac54105bccf199930885f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "page" | "plan" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "schema" | "slide" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "video" | "whiteboard" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchJiraBoard_AtlassianSearchPage$data = {
  readonly __typename: "SearchResultJiraBoard";
  readonly board: {
    readonly boardFrontendUrl: AGG$URL | null | undefined;
    readonly iconUrl: AGG$URL | null | undefined;
  } | null | undefined;
  readonly description: string;
  readonly iconUrl: string | null | undefined;
  readonly id: string;
  readonly lastModifiedDate: string | null | undefined;
  readonly title: string;
  readonly type: SearchResultType;
  readonly url: string;
  readonly " $fragmentType": "searchJiraBoard_AtlassianSearchPage";
};
export type searchJiraBoard_AtlassianSearchPage$key = {
  readonly " $data"?: searchJiraBoard_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchJiraBoard_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "iconUrl"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "searchJiraBoard_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "url"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "ScalarField",
      "name": "description"
    },
    {
      "kind": "ScalarField",
      "name": "lastModifiedDate"
    },
    (v0/*: any*/),
    {
      "concreteType": "JiraBoard",
      "kind": "LinkedField",
      "name": "board",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "name": "boardFrontendUrl"
        }
      ]
    }
  ],
  "type": "SearchResultJiraBoard"
};
})();

(node as any).hash = "4bd8e621e374695ab53532c4f4d11d01";

export default node;
